declare namespace $ {

	type $mol_check_box__title_shm_hitalama_settings_interface_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_settings_interface_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_interface['touch_hints_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	export class $shm_hitalama_settings_interface extends $mol_page {
		touch_hints_enabled( next?: boolean ): boolean
		Touch_hints( ): $mol_check_box
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=interface.view.tree.d.ts.map